export enum ActivitySeverity {
  Error = "Error",
  Warning = "Warning",
  Information = "Information"
}

export enum ActivityProcess {
  Create = "Create",
  Delete = "Delete",
  Archive = "Archive",
  Edit = "Edit",
  Move = "Move",
  Update = "Update",
  Upload = "Upload",
  Download = "Download",
  Export = "Export",
  Import = "Import",
  Publish = "Publish",
  Conversion = "Conversion",
  MediaConversion = "MediaConversion",
  Cleanup = "Cleanup",
  Translate = "Translate",
  Assign = "Assign",
  Unassign = "Unassign",
  Merge = "Merge"
}

export enum ActivityObject {
  Data = "Data",
  MediaData = "MediaData",

  Attribute = "Attribute",
  Attributes = "Attributes",
  AttributeGroup = "AttributeGroup",
  AttributeGroups = "AttributeGroups",
  Catalog = "Catalog",
  Catalogs = "Catalogs",
  CatalogNode = "CatalogNode",
  CatalogNodes = "CatalogNodes",
  Article = "Article",
  Articles = "Articles",

  File = "File",
  Files = "Files",
  Connection = "Connection",
  Connections = "Connections",

  Language = "Language",
  Languages = "Languages",
  Project = "Project",
  Projects = "Projects",
  MergeProject = "MergeProject",
  TranslationProject = "TranslationProject",
  TranslationProjects = "TranslationProjects",
  MappingProject = "MappingProject",
  MappingProjects = "MappingProjects",

  User = "User",
  Users = "Users",
  License = "License",
  Licenses = "Licenses",

  Search = "Search",
  Searches = "Searches",
  Filter = "Filter",
  Filters = "Filters",
  CatalogFilter = "CatalogFilter",
  CatalogFilters = "CatalogFilters"
}

export enum ActivityStatus {
  Unknown = "Unknown",

  Successful = "Successful",

  WithWarning = "WithWarning",
  WithAtLeastOneWarning = "WithAtLeastOneWarning",
  WithWarnings = "WithWarnings",

  WithError = "WithError",
  WithAtLeastOneError = "WithAtLeastOneError",
  WithErrors = "WithErrors"
}

export enum ActivityAction {
  Unknown = "Unknown",

  Completed = "Completed",
  Canceled = "Canceled",
  CanceledByUser = "CanceledByUser",
  Skipped = "Skipped"
}
